import { CommonModule } from '@angular/common';
import { NgModule } from "@angular/core";
import { ButtonToggleComponent } from "./button-toggle.component";
import { ButtonToggleInnerComponent } from "./button-toggle-inner/button-toggle-inner.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

@NgModule({
	declarations: [ButtonToggleComponent, ButtonToggleInnerComponent],
	imports: [CommonModule, FormsModule, ReactiveFormsModule],
	exports: [ButtonToggleComponent, ButtonToggleInnerComponent]
})
export class ButtonToggleModule { }
